import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ChargeKindSchema } from '../billing/charge-kind.ts'
import { ProjectIdSchema } from '../unique-id.models.ts'

export const IssueChargeInvoiceCurrencySchema = z.enum(['dollars', 'credits'])
export type IssueChargeInvoiceCurrency = ZodInfer<
  typeof IssueChargeInvoiceCurrencySchema
>

export const IssueChargeInvoiceForProjectInputSchema = z.object({
  projectId: ProjectIdSchema,
  amount: z.number().positive().optional(),
  kind: ChargeKindSchema.optional(),
  currency: IssueChargeInvoiceCurrencySchema.optional(),
  description: z.string().min(1).optional(),
})

export type IssueChargeInvoiceForProjectInput = ZodInfer<
  typeof IssueChargeInvoiceForProjectInputSchema
>
